import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "The Organization",
    body: "Masters Pro Boxing is the professional sanctioning body built exclusively for fighters aged 40 to 55 — a division where ring IQ, craft and courage matter more than calendar years.",
  },
  {
    num: "02",
    title: "Who Can Fight",
    body: "Open to professionals with a recorded W-L-D and freshers starting at 0-0-0. Every applicant is reviewed by the MPB sanctioning committee against our matchmaking parity standard.",
  },
  {
    num: "03",
    title: "The Standard",
    body: "Full medical protocol before licensure — cardiac screening, neurological assessment and ringside clearance. No shortcuts. Veteran fighters deserve championship-grade safety.",
  },
];

export default function Manifesto() {
  return (
    <section id="about" className="py-24 lg:py-32" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <motion.p
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-mono2 text-[10px] sm:text-xs tracking-[0.4em] text-[#E10600] uppercase mb-4 flex items-center gap-4"
        >
          <span className="h-px w-10 bg-[#E10600]" /> The Manifesto
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] text-white mb-16"
        >
          Built for the <span className="text-[#E10600]">veteran</span> fighter
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-zinc-800/60 border border-zinc-800/60">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.num}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.12, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              className="group bg-[#0d0d0d] hover:bg-[#111111] p-8 sm:p-10 transition-colors duration-500"
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <span className="font-display text-6xl text-stroke group-hover:text-[#E10600] group-hover:[-webkit-text-stroke:0px] transition-all duration-500">
                {c.num}
              </span>
              <h3 className="font-cond font-bold text-2xl uppercase tracking-wide text-white mt-6 mb-4">{c.title}</h3>
              <p className="text-sm sm:text-base text-zinc-400 leading-relaxed">{c.body}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
